import ProfitableGoingConcern from './ProfitableGoingConcern.router';

export default ProfitableGoingConcern;

export { default as profitableGoingConcernRoutes } from './routes';
